import * as React from "react";
const SvgFiRrCommentQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-question_svg__a)">
      <path
        fill="#062147"
        d="M11.904 16a1.5 1.5 0 1 1-.001 3 1.5 1.5 0 0 1 .001-3m1-2c0-.561.408-1.225.928-1.512a4.02 4.02 0 0 0 2.009-4.223c-.283-1.613-1.607-2.938-3.221-3.221a4.03 4.03 0 0 0-3.289.874A4 4 0 0 0 7.903 8.98a1 1 0 1 0 2 0 2.002 2.002 0 0 1 2.371-1.967c.787.138 1.458.81 1.596 1.596a1.995 1.995 0 0 1-1.004 2.125c-1.156.637-1.963 1.979-1.963 3.264a1 1 0 1 0 2 0zM24 19v-6.66C24 5.86 19.096.454 12.836.028A12.05 12.05 0 0 0 3.509 3.52 12.02 12.02 0 0 0 .03 12.854C.47 19.208 6.082 24 13.084 24h5.917A5.005 5.005 0 0 0 24 19M12.701 2.024C17.916 2.378 22 6.909 22 12.339v6.66c0 1.654-1.346 3-3 3h-5.917c-6.035 0-10.686-3.904-11.059-9.284a10.02 10.02 0 0 1 2.899-7.781A10.02 10.02 0 0 1 12.7 2.023z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentQuestion;
